"use client";

import { usePathname } from "next/navigation";
import { ReactNode } from "react";

interface NavbarWrapperProps {
  children: ReactNode;
}

/**
 * Client-side wrapper for Navigation that conditionally renders
 * based on the current pathname. This replaces the server-side
 * headers() check that required force-dynamic.
 *
 * Usage: Wrap the server-side Navigation component with this wrapper in the layout.
 * This allows the server component to be passed through (as children) rather than
 * being imported inside a client component.
 */
export function NavbarWrapper({ children }: NavbarWrapperProps) {
  const pathname = usePathname();

  // Hide navbar on build-studio and design-project pages (except cancel pages)
  const shouldShowNavbar =
    (!pathname?.startsWith("/build-studio") &&
      !pathname?.startsWith("/design-project")) ||
    pathname?.includes("/cancel");

  if (!shouldShowNavbar) {
    return null;
  }

  return <>{children}</>;
}
